import contoCorrenteAxios from './contoCorrenteAxios'

export const contiCorrenti = () => {
  return contoCorrenteAxios.get(`/contiCorrenti`)
}

export const contoCorrente = (bankId,contoCorrenteId) => {
  return contoCorrenteAxios.get('/'+bankId+`/${contoCorrenteId}`)
}

export const postContoCorrente = (bankId,contoCorrente) => {
  return contoCorrenteAxios.post('/'+bankId+`/create`, contoCorrente)
}

export const putContoCorrente = (bankId,contoCorrente) => {
  return contoCorrenteAxios.put('/'+bankId+`/update`, contoCorrente)
}

export const enableContoCorrente = (bankId,contoCorrente) => {
  return contoCorrenteAxios.put('/'+bankId+`/enable`, contoCorrente)
}

export const disableContoCorrente = (bankId,contoCorrente) => {
  return contoCorrenteAxios.put('/'+bankId+`/disable`, contoCorrente)
}

export const deleteContoCorrente = (bankId,contoCorrente) => {
  return contoCorrenteAxios.put('/'+bankId+`/delete`, contoCorrente)
}

